const state = {
  itens: []
}

const getters = {
  getItens(state) {
    return state.itens
  }
}

const mutations = {
  adicionarTodos(state, linhas) {
    state.itens = linhas
  },
  adicionar(state, linha) {
    state.itens.push(linha)
  },
  remover(state, linha) {
    state.itens = state.itens.filter(item => item !== linha)
  },
  resetar(state) {
    state.itens = []
  }
}

const actions = {
  adicionarTodos: ({ commit }, linhas) => {
    commit("adicionarTodos", linhas)
  },
  adicionar: ({ commit }, linha) => {
    commit("adicionar", linha)
  },
  remover: ({ commit }, linha) => {
    commit("remover", linha)
  },
  resetar: ({ commit }) => {
    commit("resetar")
  }
}

export default { namespaced: true, state, mutations, getters, actions }
